import { render } from "./CustomerLayout.vue?vue&type=template&id=579b12f9"
import script from "./CustomerLayout.vue?vue&type=script&lang=js"
export * from "./CustomerLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__